export default {"src":"/_next/static/media/Benevento.55bf99b8.svg","height":218,"width":250,"blurWidth":0,"blurHeight":0};